import React, { FC } from 'react';
import { Box, Dialog, styled, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { StyledDialogTitle } from '../styled/Dialog/StyledDialogTitle';
import { StyledDialogContent } from '../styled/Dialog/StyledDialogContent';
import { ProductStock } from '../../models/ProductStock';
import { useTranslation } from 'react-i18next';

const StyledWrapper = styled(Box)(({ theme }) => ({
    display: 'flex',
}));

const StyledItem = styled(Box)(({ theme }) => ({
    flex: 1,
}));

const StockStatusDialog: FC<StockStatusDialogProps> = ({
    open,
    stocks,
    onClose,
}) => {
    const { t } = useTranslation('product', {
        keyPrefix: 'PRODUCT.STOCKS',
    });

    return (
        <Dialog open={open} onClose={onClose} maxWidth={'sm'} fullWidth>
            <StyledDialogTitle>
                {t('STOCK')}
                <CloseIcon sx={{ cursor: 'pointer' }} onClick={onClose} />
            </StyledDialogTitle>
            <StyledDialogContent>
                {stocks[0].locations.map((item) => (
                    <StyledWrapper key={item.location}>
                        <StyledItem>
                            <Typography paragraph>
                                {t('DIALOG.LOCATION', {
                                    location: item.location,
                                })}
                                :
                            </Typography>
                        </StyledItem>
                        <StyledItem>
                            <Typography paragraph>
                                {t('DIALOG.STOCK', {
                                    stock: item.quantity,
                                })}
                            </Typography>
                        </StyledItem>
                    </StyledWrapper>
                ))}
            </StyledDialogContent>
        </Dialog>
    );
};

type StockStatusDialogProps = {
    open: boolean;
    stocks: ProductStock[];
    onClose: () => void;
};

export default StockStatusDialog;
